import PrintFileIcon from 'src/assets/print_file_template_icon.svg';

const SectionLabel = ({ label, suffix }: { label: string; suffix?: string }) => (
  <p style={{ margin: '0.625rem 0 0.25rem', fontSize: '0.875rem', color: '#1a1a1a', fontWeight: 400 }}>
    <strong>{label}</strong>{suffix ? ` ${suffix}` : ''}
  </p>
);

const BulletList = ({ items }: { items: string[] }) => (
  <ul style={{ margin: '0.25rem 0 0', paddingLeft: '1rem', listStyleType: 'disc' }}>
    {items.map((item) => (
      <li key={item} style={{ fontSize: '0.875rem', color: '#1a1a1a', marginBottom: '0.125rem', fontWeight: 400 }}>
        {item}
      </li>
    ))}
  </ul>
);

const PrintFileTooltipContent = () => {
  return (
    <div style={{ padding: '0.5rem 0.25rem', maxWidth: '26rem', color: '#1a1a1a' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', borderBottom: '1px solid #e0e0e0', paddingBottom: '0.5rem', marginBottom: '0.25rem' }}>
        <img alt="Print File Name Template" style={{ width: '1.25rem', height: '1.25rem', flexShrink: 0 }} src={PrintFileIcon} />
        <span style={{ fontSize: '0.9375rem', fontWeight: 600, color: '#1a1a1a' }}>Print File Name Template</span>
      </div>

      <SectionLabel label="Tracking:" suffix="Unique job ID (e.g., 0000001234)" />

      <SectionLabel label="JobType (1-11):" />
      <BulletList items={[
        '1 = Domestic First Class',
        '2 = Domestic Priority',
        '3 = Domestic Overnight',
        '4 = Certified Mail',
        '5 = Mexico First Class',
        '6 = Mexico Priority',
        '7 = Canada First Class',
        '8 = Canada Priority',
        '9 = International First Class',
        '10 = International Priority',
        '11 = International Overnight (incl. of Mexico & Canada)',
      ]} />

      <SectionLabel label="SheetCount:" suffix="Total number of physical sheets inserted per recipient (not page count)" />

      <SectionLabel label="PagesPerSheet (1-2):" />
      <BulletList items={['1 = Single-sided', '2 = Double-sided']} />

      <SectionLabel label="ColoredInk (1-2):" />
      <BulletList items={['1 = Black Ink (Default)', '2 = Colored']} />

      <SectionLabel label="ReturnEnvelope (1-2):" />
      <BulletList items={['1 = No', '2 = Yes']} />

      <SectionLabel label="Ballot (0-2)" suffix="Paper color of the ballot:" />
      <BulletList items={['0 = No ballot', '1 = White paper', '2 = Colored']} />

      <SectionLabel label="FirstBallotSheet:" suffix="Integer with the first sheet that a ballot is on of a print file" />
      <BulletList items={['If Ballot = 0, then FirstBallotSheet = 0']} />

      <SectionLabel label="LastBallotSheet:" suffix="Integer with the last sheet that a ballot is on of a print file" />
      <BulletList items={['If Ballot = 0, then LastBallotSheet = 0']} />

      <SectionLabel label="Mailing# (1-100000):" suffix="Number corresponds with the sequential count of print files–the first print file for a job receives 1, the second receives 2, and so on for all of the created print files." />
    </div>
  );
};

export default PrintFileTooltipContent;
